module.exports = __webpack_public_path__ + "static/media/dollar-sign-w-blue-bground-icon.22650af0.svg";